import React from "react";
import { Box, Grid, Typography, Paper, useTheme } from "@material-ui/core";
import { Icon } from "@iconify/react";
import { formatDate } from "../types/ProductUtils";
import { CustomTheme } from "../../../../../../types/customTheme";

interface SystemInformationSectionProps {
  productData: any;
  wrapperData: any;
}

const SystemInformationSection: React.FC<SystemInformationSectionProps> = ({
  productData,
  wrapperData,
}) => {
    const theme: CustomTheme = useTheme();
  return (
    <Paper
      elevation={0}
      style={{
        marginBottom: "24px",
        borderRadius: "16px",
        backgroundColor: theme.palette.background.menuProductColor,
        overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.05)",
      }}
    >
      <Box style={{ padding: "20px 24px" }}>
        {/* Section Header */}
        <Box display="flex" alignItems="center" mb={3}>
          <Box
            style={{
              backgroundColor: "#5e35b1",
              borderRadius: "8px",
              padding: "6px",
              marginRight: "12px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon icon="lucide:info" width="20" style={{ color: "white" }} />
          </Box>
          <Box>
            <Typography variant="h6" style={{ fontWeight: "bold" }} align="left">
              System Information
            </Typography>
            <Typography variant="caption" align="left">
              Read-only system information.
            </Typography>
          </Box>
        </Box>

        {/* Info Grid */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Typography variant="caption" style={{ display: "block" }} align="left">
              Version
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: 600, marginTop: "4px" }}
              align="left"
            >
              {productData?.version || wrapperData?.version || "3"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="caption" style={{ display: "block" }} align="left">
              Created
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: 600, marginTop: "4px" }}
              align="left"
            >
              {formatDate(productData?.created || wrapperData?.created) ||
                "12 Jan 2024, 10:30 AM"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="caption" style={{ display: "block" }} align="left">
              Updated
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: 600, marginTop: "4px" }}
              align="left"
            >
              {formatDate(productData?.updated || wrapperData?.updated) ||
                "10 May 2024, 02:15 PM"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default SystemInformationSection;